import React from 'react'
import RestaurantDetails from '../Components/RestaurantDetails'
import AppLayout from '../Components/AppLayout'

function RestaurantPage() {
  return (
    <div>
      <AppLayout>
        <RestaurantDetails />
      </AppLayout>
    </div>

  )
}

export default RestaurantPage